import React, { useState } from 'react';

const TaxFAQ = () => {
    const [activeIndex, setActiveIndex] = useState(0);

    const faqData = [
        {
            question: "What are the fundamentals of GST?",
            answer: (
                <>
                    <p>Goods and Services Tax (GST) is an indirect tax that replaced many indirect taxes in India. Key fundamentals:</p>
                    <ul>
                        <li><strong>Dual Structure:</strong> CGST (Central), SGST (State), and IGST (Integrated for inter-state)</li>
                        <li><strong>Tax Slabs:</strong> 0%, 5%, 12%, 18%, and 28% for different goods/services</li>
                        <li><strong>Input Tax Credit (ITC):</strong> Allows businesses to claim credit for taxes paid on inputs</li>
                        <li><strong>GSTIN:</strong> 15-digit unique identification number for businesses</li>
                        <li><strong>Threshold Limits:</strong> ₹40 lakh (goods), ₹20 lakh (services) for normal states (lower for special category states)</li>
                    </ul>
                </>
            )
        },
        {
            question: "How does Input Tax Credit (ITC) work in GST?",
            answer: (
                <>
                    <p>Input Tax Credit mechanism under GST:</p>
                    <ol>
                        <li>Businesses can claim credit for GST paid on purchases (inputs) against GST liability on sales (output)</li>
                        <li>ITC is available only when the supplier has filed returns and paid tax to government</li>
                        <li>ITC can be claimed through GSTR-2A/2B (auto-populated from supplier's returns)</li>
                        <li>Certain items are blocked from ITC (e.g., motor vehicles, club memberships)</li>
                        <li>ITC must be claimed within specified time limits (earlier of due date of September return or annual return)</li>
                    </ol>
                    <p>Proper documentation (invoice, debit note, etc.) is essential for claiming ITC.</p>
                </>
            )
        },
        {
            question: "What is the difference between GSTR-1 and GSTR-3B?",
            answer: (
                <>
                    <div style={{
                        overflowX: 'auto',
                        margin: '15px 0'
                    }}>
                        <table style={{
                            width: '100%',
                            borderCollapse: 'collapse',
                            margin: '10px 0',
                            border: '1px solid #dadce0'
                        }}>
                            <thead>
                                <tr>
                                    <th style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        backgroundColor: '#f1f3f4',
                                        border: '1px solid #dadce0'
                                    }}>Aspect</th>
                                    <th style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        backgroundColor: '#f1f3f4',
                                        border: '1px solid #dadce0'
                                    }}>GSTR-1</th>
                                    <th style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        backgroundColor: '#f1f3f4',
                                        border: '1px solid #dadce0'
                                    }}>GSTR-3B</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>Purpose</td>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>Outward supplies details (sales)</td>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>Summary return with tax payment</td>
                                </tr>
                                <tr>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>Frequency</td>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>Monthly/Quarterly (for QRMP scheme)</td>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>Always monthly</td>
                                </tr>
                                <tr>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>Due Date</td>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>11th of next month (monthly filers)</td>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>20th of next month</td>
                                </tr>
                                <tr>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>Invoice-level Data</td>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>Yes (B2B invoices)</td>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>No (summary only)</td>
                                </tr>
                                <tr>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>ITC Claim</td>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>No</td>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>Yes (provisional)</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </>
            )
        },
        {
            question: "How to generate a GST challan for payment?",
            answer: (
                <>
                    <p>Steps to generate GST challan on GST portal:</p>
                    <ol>
                        <li>Login to GST portal (www.gst.gov.in)</li>
                        <li>Go to Services → Payments → Create Challan</li>
                        <li>Select the tax period (month/quarter) for which payment is being made</li>
                        <li>Enter the amount to be paid under each head (CGST, SGST, IGST, Cess)</li>
                        <li>Select payment mode:
                            <ul>
                                <li>Online (Net Banking, Credit/Debit Card, UPI)</li>
                                <li>Over the Counter (OTC) at authorized banks</li>
                                <li>NEFT/RTGS</li>
                            </ul>
                        </li>
                        <li>Generate Challan (CPIN will be created)</li>
                        <li>Make payment and save the receipt (contains CIN for future reference)</li>
                    </ol>
                    <p>Note: GST payments must be made before filing GSTR-3B.</p>
                </>
            )
        },
        {
            question: "What are the key TDS sections and threshold limits?",
            answer: (
                <>
                    <p>Important TDS sections with threshold limits (FY 2023-24):</p>
                    <div style={{
                        overflowX: 'auto',
                        margin: '15px 0'
                    }}>
                        <table style={{
                            width: '100%',
                            borderCollapse: 'collapse',
                            margin: '10px 0',
                            border: '1px solid #dadce0'
                        }}>
                            <thead>
                                <tr>
                                    <th style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        backgroundColor: '#f1f3f4',
                                        border: '1px solid #dadce0'
                                    }}>Section</th>
                                    <th style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        backgroundColor: '#f1f3f4',
                                        border: '1px solid #dadce0'
                                    }}>Nature of Payment</th>
                                    <th style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        backgroundColor: '#f1f3f4',
                                        border: '1px solid #dadce0'
                                    }}>Threshold Limit (₹)</th>
                                    <th style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        backgroundColor: '#f1f3f4',
                                        border: '1px solid #dadce0'
                                    }}>TDS Rate (%)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>192</td>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>Salary</td>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>As per income tax slabs</td>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>Slab rate</td>
                                </tr>
                                <tr>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>194C</td>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>Contractor payments</td>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>30,000 (single), 1,00,000 (annual)</td>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>1% (individual/HUF), 2% (others)</td>
                                </tr>
                                <tr>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>194I</td>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>Rent</td>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>2,40,000 p.a.</td>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>10% (land/building), 2% (machinery/equipment)</td>
                                </tr>
                                <tr>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>194J</td>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>Professional/Technical services</td>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>30,000 (single)</td>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>10% (2% for call center services)</td>
                                </tr>
                                <tr>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>194H</td>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>Commission/Brokerage</td>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>15,000 (single)</td>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>5%</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </>
            )
        },
        {
            question: "What is the difference between Form 24Q and Form 26Q?",
            answer: (
                <>
                    <p>Key differences between TDS returns:</p>
                    <div style={{
                        overflowX: 'auto',
                        margin: '15px 0'
                    }}>
                        <table style={{
                            width: '100%',
                            borderCollapse: 'collapse',
                            margin: '10px 0',
                            border: '1px solid #dadce0'
                        }}>
                            <thead>
                                <tr>
                                    <th style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        backgroundColor: '#f1f3f4',
                                        border: '1px solid #dadce0'
                                    }}>Feature</th>
                                    <th style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        backgroundColor: '#f1f3f4',
                                        border: '1px solid #dadce0'
                                    }}>Form 24Q</th>
                                    <th style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        backgroundColor: '#f1f3f4',
                                        border: '1px solid #dadce0'
                                    }}>Form 26Q</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>Applicability</td>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>TDS on salaries (Section 192)</td>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>TDS on payments other than salary (Sections 193-196D)</td>
                                </tr>
                                <tr>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>Frequency</td>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>Quarterly (with Annexure II for salary details)</td>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>Quarterly</td>
                                </tr>
                                <tr>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>Due Date</td>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>31st of next month (Q1-Q3), 31st May (Q4)</td>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>Same as Form 24Q</td>
                                </tr>
                                <tr>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>Challan Details</td>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>Requires challan details for salary TDS</td>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>Requires challan details for non-salary TDS</td>
                                </tr>
                                <tr>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>Form 16 Generation</td>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>Basis for Form 16 for employees</td>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>Basis for Form 16A for deductees</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </>
            )
        },
        {
            question: "How to generate Form 16 for employees?",
            answer: (
                <>
                    <p>Steps to generate Form 16 (Part A and B):</p>
                    <ol>
                        <li>Ensure all quarterly TDS returns (Form 24Q) are filed for the financial year</li>
                        <li>Login to TRACES portal (www.tdscpc.gov.in) with TAN credentials</li>
                        <li>Navigate to 'Downloads' → 'Form 16'</li>
                        <li>Select financial year and quarter (Q4 for annual Form 16)</li>
                        <li>Validate PANs of employees and request Form 16</li>
                        <li>After processing (usually 1-2 days), download the auto-generated Form 16 Part A</li>
                        <li>Prepare Part B (salary details and tax computation) using company's payroll data</li>
                        <li>Combine Part A and Part B, validate the details, and issue to employees by June 15th</li>
                    </ol>
                    <p>Form 16 contains:
                        <ul>
                            <li>Part A: TDS details (from TRACES)</li>
                            <li>Part B: Salary breakup and tax computation (prepared by employer)</li>
                        </ul>
                    </p>
                </>
            )
        },
        {
            question: "What are the key Excel templates used in GST and TDS work?",
            answer: (
                <>
                    <p>Essential Excel templates for tax professionals:</p>
                    <div style={{
                        overflowX: 'auto',
                        margin: '15px 0'
                    }}>
                        <table style={{
                            width: '100%',
                            borderCollapse: 'collapse',
                            margin: '10px 0',
                            border: '1px solid #dadce0'
                        }}>
                            <thead>
                                <tr>
                                    <th style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        backgroundColor: '#f1f3f4',
                                        border: '1px solid #dadce0'
                                    }}>Template</th>
                                    <th style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        backgroundColor: '#f1f3f4',
                                        border: '1px solid #dadce0'
                                    }}>Purpose</th>
                                    <th style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        backgroundColor: '#f1f3f4',
                                        border: '1px solid #dadce0'
                                    }}>Key Formulas/Functions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>GST Reconciliation</td>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>Match GSTR-2A with purchase register</td>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>VLOOKUP, SUMIFS, IFERROR, Conditional Formatting</td>
                                </tr>
                                <tr>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>TDS Calculator</td>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>Compute TDS for various sections</td>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>IF, AND, IFS, ROUND, Data Validation</td>
                                </tr>
                                <tr>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>GSTR-1 Preparation</td>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>Consolidate sales data for return filing</td>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>Pivot Tables, TEXT, CONCATENATE, Filters</td>
                                </tr>
                                <tr>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>HRA Calculator</td>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>Compute exempt HRA for employees</td>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>MIN, MAX, logical comparisons</td>
                                </tr>
                                <tr>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>ITR Preparation</td>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>Consolidate income and tax details</td>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>SUMIF, INDEX-MATCH, Named Ranges</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </>
            )
        }
    ];

    const toggleFAQ = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <div style={{
            fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
            lineHeight: 1.6,
            color: '#202124',
            padding: '20px',
            maxWidth: '1200px',
            margin: '0 auto'
        }}>
            <p style={{
                color: 'blue',
                textAlign: 'center',
                fontSize:"35px",
                fontWeight:"bold",
                marginBottom: '30px'
            }}>
                Tax <span style={{ color: 'orange' }}>Professional</span> 
            </p>

            <div style={{
                backgroundColor: '#fff',
                borderRadius: '8px',
                boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
                overflow: 'hidden'
            }}>
                {faqData.map((item, index) => (
                    <div
                        key={index}
                        style={{
                            borderBottom: '1px solid #dadce0'
                        }}
                    >
                        <div
                            style={{
                                padding: '16px 24px',
                                cursor: 'pointer',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                fontWeight: 500,
                                fontSize: '18px',
                                transition: 'background-color 0.2s',
                                backgroundColor: activeIndex === index ? '#f1f3f4' : 'transparent'
                            }}
                            onClick={() => toggleFAQ(index)}
                        >
                            {item.question}
                            <span style={{
                                fontSize: '24px',
                                color: '#4285f4',
                                transition: 'transform 0.3s'
                            }}>{activeIndex === index ? '-' : '+'}</span>
                        </div>
                        <div style={{
                            padding: activeIndex === index ? '0 24px 20px' : '0 24px',
                            maxHeight: activeIndex === index ? '1000px' : '0',
                            overflow: 'hidden',
                            transition: 'max-height 0.3s ease-out, padding 0.3s ease'
                        }}>
                            <div style={{ paddingTop: '8px' }}>
                                {item.answer}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default TaxFAQ;